import {ApolloClient, InMemoryCache} from '@apollo/client';
import {GQL_HOST} from './constants';

export const client = new ApolloClient({
  uri: GQL_HOST,
  cache: new InMemoryCache(),
});
